import { get } from "./base";

export async function getNewsDetail(newsId) {
    let respObj = await get(`/edu-classroom/platforminformation/infocontent/${newsId}`);
    if (respObj != false) {
        // 处理接口数据
        return respObj;
    } else {
        // 返回测试数据
        return {}
    }
}
